/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ZEP QUIZ
 * Zep Quiz API
 * OpenAPI spec version: 0.0.1
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../../httpClient';
import { httpsInstance } from '../../httpClient';
import type { ImportSchoolsBody } from '../_model/importSchoolsBody';
import type { SearchSchoolsParams } from '../_model/searchSchoolsParams';
import type { SuccessBody } from '../_model/successBody';
import type { SuccessBodyZPageSchoolSearchRes } from '../_model/successBodyZPageSchoolSearchRes';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const importSchools = (
  importSchoolsBody: BodyType<ImportSchoolsBody>,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, importSchoolsBody.file);

  return httpsInstance<SuccessBody>(
    {
      url: `/schools/import-csv`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getImportSchoolsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importSchools>>,
    TError,
    { data: BodyType<ImportSchoolsBody> },
    TContext
  >;
  request?: SecondParameter<typeof httpsInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importSchools>>,
  TError,
  { data: BodyType<ImportSchoolsBody> },
  TContext
> => {
  const mutationKey = ['importSchools'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importSchools>>,
    { data: BodyType<ImportSchoolsBody> }
  > = props => {
    const { data } = props ?? {};

    return importSchools(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportSchoolsMutationResult = NonNullable<
  Awaited<ReturnType<typeof importSchools>>
>;
export type ImportSchoolsMutationBody = BodyType<ImportSchoolsBody>;
export type ImportSchoolsMutationError = ErrorType<unknown>;

export const useImportSchools = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof importSchools>>,
      TError,
      { data: BodyType<ImportSchoolsBody> },
      TContext
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof importSchools>>,
  TError,
  { data: BodyType<ImportSchoolsBody> },
  TContext
> => {
  const mutationOptions = getImportSchoolsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const searchSchools = (
  params: SearchSchoolsParams,
  options?: SecondParameter<typeof httpsInstance>,
  signal?: AbortSignal,
) => {
  return httpsInstance<SuccessBodyZPageSchoolSearchRes>(
    { url: `/schools/search`, method: 'GET', params, signal },
    options,
  );
};

export const getSearchSchoolsQueryKey = (params: SearchSchoolsParams) => {
  return [`/schools/search`, ...(params ? [params] : [])] as const;
};

export const getSearchSchoolsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchSchools>>,
  TError = ErrorType<unknown>,
>(
  params: SearchSchoolsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchSchools>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchSchoolsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchSchools>>> = ({
    signal,
  }) => searchSchools(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchSchools>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SearchSchoolsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchSchools>>
>;
export type SearchSchoolsQueryError = ErrorType<unknown>;

export function useSearchSchools<
  TData = Awaited<ReturnType<typeof searchSchools>>,
  TError = ErrorType<unknown>,
>(
  params: SearchSchoolsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchSchools>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchSchools>>,
          TError,
          Awaited<ReturnType<typeof searchSchools>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSearchSchools<
  TData = Awaited<ReturnType<typeof searchSchools>>,
  TError = ErrorType<unknown>,
>(
  params: SearchSchoolsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchSchools>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchSchools>>,
          TError,
          Awaited<ReturnType<typeof searchSchools>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchSchools<
  TData = Awaited<ReturnType<typeof searchSchools>>,
  TError = ErrorType<unknown>,
>(
  params: SearchSchoolsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchSchools>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useSearchSchools<
  TData = Awaited<ReturnType<typeof searchSchools>>,
  TError = ErrorType<unknown>,
>(
  params: SearchSchoolsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof searchSchools>>, TError, TData>
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getSearchSchoolsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSearchSchoolsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof searchSchools>>,
  TError = ErrorType<unknown>,
>(
  params: SearchSchoolsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof searchSchools>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchSchoolsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchSchools>>> = ({
    signal,
  }) => searchSchools(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof searchSchools>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type SearchSchoolsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchSchools>>
>;
export type SearchSchoolsSuspenseQueryError = ErrorType<unknown>;

export function useSearchSchoolsSuspense<
  TData = Awaited<ReturnType<typeof searchSchools>>,
  TError = ErrorType<unknown>,
>(
  params: SearchSchoolsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof searchSchools>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSearchSchoolsSuspense<
  TData = Awaited<ReturnType<typeof searchSchools>>,
  TError = ErrorType<unknown>,
>(
  params: SearchSchoolsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof searchSchools>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSearchSchoolsSuspense<
  TData = Awaited<ReturnType<typeof searchSchools>>,
  TError = ErrorType<unknown>,
>(
  params: SearchSchoolsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof searchSchools>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};

export function useSearchSchoolsSuspense<
  TData = Awaited<ReturnType<typeof searchSchools>>,
  TError = ErrorType<unknown>,
>(
  params: SearchSchoolsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof searchSchools>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof httpsInstance>;
  },
  queryClient?: QueryClient,
): UseSuspenseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
} {
  const queryOptions = getSearchSchoolsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(
    queryOptions,
    queryClient,
  ) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
